import { Box } from "@mui/material";

export function UserManagement(){
    return(
        <Box>
            UserManagement
        </Box>
    )
}